import { DashboardTableFilterTrigger } from '@shigo-ui/dashboard-ui';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import {
  campaignStatusFilterOptions,
  lineItemDeliveryStatusFilterOptions,
  resolveCampaignStatusLabel,
  resolveLineItemDeliveryStatusLabel,
  type CampaignStatus,
  type LineItemDeliveryStatus,
} from '../../model';

export function LineItemFilters({
  selectedStatuses,
  selectedDeliveryStatuses,
  onStatusesChange,
  onDeliveryStatusesChange,
}: {
  selectedStatuses: CampaignStatus[];
  selectedDeliveryStatuses: LineItemDeliveryStatus[];
  onStatusesChange: (next: CampaignStatus[]) => void;
  onDeliveryStatusesChange: (next: LineItemDeliveryStatus[]) => void;
}) {
  const statusLabel = selectedStatuses.length
    ? selectedStatuses.map(resolveCampaignStatusLabel).join(', ')
    : dashboardT('campaigns.allStatuses');
  const deliveryLabel = selectedDeliveryStatuses.length
    ? selectedDeliveryStatuses.map(resolveLineItemDeliveryStatusLabel).join(', ')
    : dashboardT('lineItems.allDeliveryStatuses');
  return (
    <>
      <FilterMenu
        ariaLabel={dashboardT('lineItems.statusFilter')}
        label={statusLabel}
        options={campaignStatusFilterOptions}
        selected={selectedStatuses}
        resolveLabel={resolveCampaignStatusLabel}
        onChange={onStatusesChange}
      />
      <FilterMenu
        ariaLabel={dashboardT('lineItems.deliveryStatusFilter')}
        label={deliveryLabel}
        options={lineItemDeliveryStatusFilterOptions}
        selected={selectedDeliveryStatuses}
        resolveLabel={resolveLineItemDeliveryStatusLabel}
        onChange={onDeliveryStatusesChange}
      />
    </>
  );
}

function FilterMenu<TValue extends string>({
  ariaLabel,
  label,
  options,
  selected,
  resolveLabel,
  onChange,
}: {
  ariaLabel: string;
  label: string;
  options: readonly TValue[];
  selected: TValue[];
  resolveLabel: (value: TValue) => string;
  onChange: (next: TValue[]) => void;
}) {
  const selectedValues = new Set(selected);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <DashboardTableFilterTrigger label={label} aria-label={ariaLabel} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option}
            checked={selectedValues.has(option)}
            onSelect={(event) => {
              event.preventDefault();
            }}
            onCheckedChange={(checked) => {
              onChange(
                checked
                  ? Array.from(new Set([...selected, option]))
                  : selected.filter((item) => item !== option),
              );
            }}
          >
            {resolveLabel(option)}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
